import { render, staticRenderFns } from "./ListTerms.vue?vue&type=template&id=4dba6056&"
import script from "./ListTerms.vue?vue&type=script&lang=js&"
export * from "./ListTerms.vue?vue&type=script&lang=js&"
import style0 from "./ListTerms.vue?vue&type=style&index=0&id=4dba6056&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports